export default "__VITE_ASSET__c01fb43f__"